import React, { forwardRef, Fragment } from 'react';
import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

const RadioButtonGroupComponent = forwardRef(
  ({ label = '', name, defaultValue = false, options = [], value, ...props }, ref) => {

    return (
      <Fragment>
        <FormLabel>{label}</FormLabel>
        <RadioGroup
          ref={ref}
          row
          defaultValue={defaultValue}
          name={name}
          value={value}
          {...props}
        >
          {options?.map((item, index) => (
            <FormControlLabel
              key={index}
              value={item.value}
              control={<Radio />}
              label={item.label}
            />
          ))}
        </RadioGroup>
      </Fragment>
    );
  }
);

export default RadioButtonGroupComponent;
